import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Star } from "lucide-react";
import { CONTACT, SERVICES } from "../../lib/api";

export default function Footer() {
  return (
    <footer className="mt-24 bg-[#141110] text-[#F0EBE1]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 lg:grid-cols-4">
        <div className="lg:col-span-2 max-w-md">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 rounded-full bg-[#C25B48] grid place-items-center font-display font-bold">
              E
            </div>
            <div className="font-display text-xl">Express Logistics</div>
          </div>
          <p className="text-white/70 leading-relaxed">
            Premium packers and movers based in Hyderabad. Serving families and
            businesses across India since {CONTACT.since} — one carefully-packed
            box at a time.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-sm">
            <Star className="w-4 h-4 fill-[#E8B04D] text-[#E8B04D]" />
            <span className="font-medium">{CONTACT.rating}</span>
            <span className="text-white/60">· {CONTACT.reviews} Google reviews</span>
          </div>
        </div>

        <div>
          <div className="font-display text-lg mb-4">Services</div>
          <ul className="space-y-2 text-sm text-white/70">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.key}>
                <Link to="/services" className="hover:text-white transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-display text-lg mb-4">Reach us</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#C25B48]" />
              <span>{CONTACT.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#C25B48]" />
              <a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-white">
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#C25B48]" />
              <span>{CONTACT.email}</span>
            </li>
            <li className="flex gap-3">
              <Clock className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#C25B48]" />
              <span>{CONTACT.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Express Logistics Packers And Movers. All rights reserved.</div>
          <Link to="/admin/login" className="hover:text-white/80" data-testid="footer-admin-link">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
